export default __webpack_public_path__ + "static/bg-superhuman-ai--mobile-9d57e64a5968c9b3b96e21527eccfc91.jpg";